



export class CounsellorWorkingHoursVM {
    
    dayOfWeek?: number;
    
    startTime?: string;
    
    endTime?: string;
    
}
